module.exports = __webpack_public_path__ + "static/media/doctorRegistro.edafd184.jpg";